export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-22',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
